module.exports = __webpack_public_path__ + "img/invite.fca6112d.jpg";